import React from "react";
import TextInfo from "@/bit/components/components.text";
import Button from "@/bit/components/components.button";
import Price from "@/bit/components/components.price";
import IconGlyph from "@/bit/components/components.icon-glyph";

const SMALL_CARD_CONTENT_TAGGING_INFO = {
  componentName: "SmallFeatureCard",
  componentVariation: "all",
};

const checkIfEmpty = (element) => {
  let res = true;
  if (element?.text || element?.price) {
    res = false;
  }

  return res;
};

const CardContent = ({ cardProps, cmsHandler }) => {
  const {
    "cms-atom-price-1": cardPrice1,
    "cms-atom-price-2": cardPrice2,
    "cms-atom-button-1": cardButton1,
    "cms-atom-text-2": cardText2,
    "cms-atom-text-3": cardText3,
    "cms-atom-text-4": cardText4,
    "cms-atom-text-1": cardText1,
    "cms-atom-icon-1": cardIcon1,
    loaded = true,
  } = cardProps;

  let taggingButton1 = {
    ...SMALL_CARD_CONTENT_TAGGING_INFO,
    componentContent: cardButton1?.label || "Lo quiero",
    ...cardButton1?.taggingInfo,
  };

  // Que haya un minimo de contenido de price
  const isPriceContentEmpty =
    [cardPrice1, cardPrice2, cardText3, cardText4].every(checkIfEmpty) &&
    !cmsHandler;

  return (
    <div className={`small-feature-card-content`}>
      <div className={`content`}>
        <IconGlyph {...cardIcon1} cmsHandler={cmsHandler} />

        <TextInfo
          {...cardText1}
          className="titulo-gap"
          cmsHandler={cmsHandler}
        />
        <TextInfo
          {...cardText2}
          className="description-gap"
          cmsHandler={cmsHandler}
        />
        <div className="card-price-content">
          {!isPriceContentEmpty && (
            <div className="price-content">
              <TextInfo
                {...cardText3}
                className="pre-price"
                cmsHandler={cmsHandler}
              />
              <div className="price-inline">
                <Price {...cardPrice2} cmsHandler={cmsHandler} />
                <Price {...cardPrice1} cmsHandler={cmsHandler} />
              </div>
              <TextInfo
                {...cardText4}
                className="post-price"
                cmsHandler={cmsHandler}
              />
            </div>
          )}
          <div className="action-buttons">
            <Button
              {...cardButton1}
              taggingInfo={taggingButton1}
              cmsHandler={cmsHandler}
            />
          </div>
        </div>
      </div>
      <div className={loaded ? "skeleton loaded" : "skeleton"} />
      <style jsx>{`.small-feature-card-content {
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #fff;
  min-width: 160px;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #eeeeee;

  &.inherited-card {
    filter: grayscale(50%) brightness(0.8);
  }
  &:hover {
    border: 1px solid #dddddd;
  }
  .card-price-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: auto;
    position: relative;
    height: 100%;
    .price-inline {
      display: flex;
      gap: 0.5rem;
      align-items: center;
    }
  }

  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 2;
    margin-top: auto;
    :global(.buttonx) {
      position: relative;
    }
    :global(.button-type--link) {
      padding: 0px;
    }
  }
  .content {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    flex: 1;

    :global(.svg-layout-size) {
      overflow: visible;
      width: fit-content;
    }

    &.content-resize {
      margin-top: 40px;
    }
    .content-price {
      display: flex;
      gap: 0.5rem;
    }
  }

  .skeleton {
    position: absolute;
    display: block;
    &.loaded {
      display: none;
    }
  }
}
`}</style>  
    </div>
  );
};

export default CardContent;
